import { render, staticRenderFns } from "./InventoryFilter.vue?vue&type=template&id=ea3b84fc"
import script from "./InventoryFilter.vue?vue&type=script&lang=ts"
export * from "./InventoryFilter.vue?vue&type=script&lang=ts"
import style0 from "./InventoryFilter.vue?vue&type=style&index=0&id=ea3b84fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports